import React, { useCallback, useEffect, useRef, useState } from 'react';
import detectEthereumProvider from '@metamask/detect-provider';

const MM_DEEPLINK = 'https://metamask.app.link/dapp/sodabits.io/pfp?do-connect';


const DEFAULT_CONTEXT = {
  accounts: [],
  chainId: '0x4',
  connect: () => {},
  isConnecting: false,
  connectMM: () => { window.location = MM_DEEPLINK },
  disconnect: () => {},
};

const MetaMaskContext = React.createContext(DEFAULT_CONTEXT);

const MetaMaskProvider = ({ children }) => {
  const [ accounts , setAccounts ] = useState([]);
  const [ context, setContext ] = useState(DEFAULT_CONTEXT);
  const [ isConnecting, setIsConnecting ] = useState(false);
  const connectRef = useRef(() => {});

  const disconnect = useCallback(() => {
    localStorage.setItem('metamask_disconnected', true);
    setAccounts([]);
  }, []);


  const connect = useCallback((returnUrl) => {
//    setAccounts(['0x210bc6fabad8206bf59919931e04b28e3390dfe5']);
//    return new Promise((resolve, reject) => {
//      resolve(['0x210bc6fabad8206bf59919931e04b28e3390dfe5']);
//    });

    setIsConnecting(true);

    return new Promise((resolve, reject) => {
      if (window.ethereum) {
        window.ethereum
          .request({ method: 'eth_requestAccounts' })
          .then((accounts) => {
            setAccounts(accounts);
            localStorage.removeItem('metamask_disconnected');
            resolve(accounts);
          })
          .finally(() => setIsConnecting(false))
          .catch((e) => { console.debug('Failed to connect to wallet: ', e); reject(e);});
      } else {
        window.location = returnUrl;
      }
    });
  }, []);
  connectRef.current = connect;

  const setupEvents = useCallback(() => {
    (async () => {
      const provider = await detectEthereumProvider();
      if (provider) {
        window.ethereum.on('accountsChanged', setAccounts);
        window.ethereum.on('chainChanged', (chainId) => {
          window.location.reload();
        });

        if (window.ethereum.isMetaMask
          && !localStorage.getItem('metamask_disconnected')
          && window.location.search.includes('do-connect')
        ) {
          setTimeout(() => {
            connectRef.current()
              .catch(() => {});
          }, 500);
        }

        const chainId = await window.ethereum.request({method: 'eth_chainId'});
        setContext((ctx) => {
          return {...ctx, chainId};
        });
      }
    })();
  }, []);

  useEffect(() => {
    setupEvents();
  }, [setupEvents]);

  useEffect(() => {
    setContext((ctx) => {
      return {
        ...ctx,
        accounts: accounts || [],
        isConnecting,
        connect,
        disconnect,
      };
    });
  }, [ accounts, connect, disconnect, isConnecting ]);



  return (
    <MetaMaskContext.Provider value={context}>
      { children }
    </MetaMaskContext.Provider>
  );
}

export {
  MetaMaskContext,
  MetaMaskProvider,
};
